var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.productionId && !_vm.isCurrentUserClient)?_c('router-link',{attrs:{"to":_vm.taskTypePath}},[_c('span',{staticClass:"tag task-type-name",style:({ 'border-left': '4px solid ' + _vm.color })},[_vm._v(" "+_vm._s(_vm.taskType.name)+" ")])]):_c('div',{class:{
    tag: true,
    'task-type-name': true,
    'no-link': true,
    deletable: _vm.deletable,
    canceled: _vm.disable
  },style:({ 'border-left': '4px solid ' + _vm.color })},[_vm._v(" "+_vm._s(_vm.taskType.name)+" "),(_vm.deletable)?_c('span',{staticClass:"delete-times",on:{"click":function($event){return _vm.$emit('delete')}}},[_vm._v(" × ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }